import { IconProps } from '@models/icons';

function PhoneFill({ size, color = '#6E6864', ...rest }:IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
         {...rest} >
        <path d="M11.1831 1C11.9716 1 12.6438 1.64235 12.644 2.45996V13.54C12.6438 14.3577 12.0008 15 11.1831 15H4.81592C3.99843 14.9998 3.35615 14.3575 3.35596 13.54V2.45996C3.35617 1.67171 3.99838 1.02944 4.78662 1H11.1831ZM5.10791 3.50098V10.4092H10.8042V3.50098H5.10791Z" fill={color}/>
    </svg>

  );
}

export default PhoneFill;
